import React from 'react';
import { trackMetaPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  children,
  href = '#precios',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizes = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const isExternal = href.startsWith('http');
  const handleClick = () => {
    if (isExternal) {
      trackMetaPixelEvent('InitiateCheckout', {
        content_name: String(children)
      });
    }
  };
  return <a href={href} onClick={handleClick} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`inline-flex items-center justify-center rounded-xl bg-cta text-center font-display font-bold text-white shadow-lg shadow-cta/25 transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-cta-hover hover:shadow-xl hover:shadow-cta/30 active:translate-y-px focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-cta ${sizes[size]} ${className}`} data-id="element-61" data-mp="ljmqimezkr0q">
      {children}
    </a>;
}